"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var AddUserIcon = function AddUserIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#333F48' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 20 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M19 9C19 8.44771 18.5523 8 18 8C17.4477 8 17 8.44771 17 9V11H15C14.4477 11 14 11.4477 14 12C14 12.5523 14.4477 13 15 13H17V15C17 15.5523 17.4477 16 18 16C18.5523 16 19 15.5523 19 15V13H21C21.5523 13 22 12.5523 22 12C22 11.4477 21.5523 11 21 11H19V9ZM4 8C4 10.28 5.72 12 8 12C10.28 12 12 10.28 12 8C12 5.72 10.28 4 8 4C5.72 4 4 5.72 4 8ZM10 8C10 9.178 9.178 10 8 10C6.822 10 6 9.178 6 8C6 6.822 6.822 6 8 6C9.178 6 10 6.822 10 8ZM4 18C4 16.346 5.346 15 7 15H9C10.654 15 12 16.346 12 18C12 18.5523 12.4477 19 13 19C13.5523 19 14 18.5523 14 18C14 15.243 11.757 13 9 13H7C4.243 13 2 15.243 2 18C2 18.5523 2.44772 19 3 19C3.55228 19 4 18.5523 4 18Z",
    fill: color
  }));
};

var _default = AddUserIcon;
exports.default = _default;